import {QuestionsAndAnswersContentType} from '@/utils/questions-and-answers/constants'
import {DEFAULT_HOST, routeTo} from '@/utils/router'

import {FaqCategoryName, getFAQsContent} from './FAQs'

export const getQuestionsAndAnswersContent = (contentType: QuestionsAndAnswersContentType) => {
  const primaryFaqCategory =
    contentType === QuestionsAndAnswersContentType.brandProtection
      ? FaqCategoryName.brandProtection
      : undefined

  const {categories} = getFAQsContent(primaryFaqCategory)

  return {
    header: {
      [QuestionsAndAnswersContentType.trademark]: {
        buttonLinkText: 'button-start-with-registration',
        buttonLinkHref: routeTo.verification.form(),
      },
      [QuestionsAndAnswersContentType.brandProtection]: {
        buttonLinkText: 'start-monitoring-button',
        buttonLinkHref: routeTo.brandMonitoring.order(),
      },
    }[contentType],
    ogImage: {
      url: `${DEFAULT_HOST}/images/og-images/${contentType}-qa-en.png`,
      width: 1200,
      height: 627,
      alt: 'QA - OG image',
    },
    home: {
      metaTitle: `questions-and-answers.${contentType}-home-meta-title`,
      metaDescription: `questions-and-answers.${contentType}-home-meta-desc`,
      breadcrumbLabel: `questions-and-answers.${contentType}-breadcrumb-label`,
      hero: {
        title: `questions-and-answers.${contentType}-home-hero-title`,
        subtitle: `questions-and-answers.${contentType}-home-hero-subtitle`,
        imageSrc: '/images/hero/light-bulb-with-r.svg',
        imageAlt: 'Light bulb with R',
      },
    },
    category: {
      metaTitle: `questions-and-answers.${contentType}-detail-meta-title`,
      metaDescription: 'questions-and-answers.answers-to-faqs-about-title',
    },
    question: {
      metaTitle: `questions-and-answers.${contentType}-detail-meta-title`,
    },
    selectTopicTitle: 'questions-and-answers.select-topic-title',
    faqTitle: 'frequently-asked-questions-title',
    resources: {
      title: 'questions-and-answers.explore-all-resources-title',
      list: [
        {
          imageSrc: '/images/blogs.svg',
          imageAlt: 'Blogs',
          title: 'menu-resources-blogs-title',
          description: 'menu-resources-blogs-desc',
          linkHref: routeTo.blog.home(),
        },
        {
          imageSrc: '/images/icons/selection.svg',
          imageAlt: 'Class assist',
          title: 'menu-resources-classes-title',
          description: 'menu-resources-classes-desc',
          linkHref: routeTo.classAssist.industry(),
        },
        {
          imageSrc: '/images/hero/academy.svg',
          imageAlt: 'Trademark academy',
          title: 'menu-resources-academy-title',
          description: 'menu-resources-academy-desc',
          linkHref: routeTo.tmAcademy.home(),
        },
        {
          imageSrc: '/images/icons/globe.svg',
          imageAlt: 'Country guide',
          title: 'menu-resources-country-guide-title',
          description: 'menu-resources-country-guide-desc',
          linkHref: routeTo.countryGuide(),
        },
      ],
    },
    relatedArticlesTitle: 'related-articles-title',
    writtenByText: 'help-written-by',
    relatedQuestionsTitle: 'questions-and-answers.related-questions-title',
    helpCenterCategories: categories,
  }
}
